import PageMyReleaseOrder from "@/views/PageMyReleaseOrder.vue"
import PageMyReleaseOrderForm from "@/views/PageMyReleaseOrderForm.vue"
import PageSearchReleaseOrder from "@/views/PageSearchReleaseOrder.vue"
import PageMyApprovalReleaseReservationInfo from "@/views/approvalRelease/PageMyApprovalReleaseReservationInfo.vue"
import PageMyApprovalRelease from "@/views/approvalRelease/PageMyApprovalRelease"
import PageMyApprovalReleaseForm from "@/views/approvalRelease/PageMyApprovalReleaseForm"

export default [
  {
    path: "/MyReleaseOrder",
    name: "PageMyReleaseOrder",
    component: PageMyReleaseOrder,
    props: true,
  },
  {
    path: "/MyReleaseOrderAuth",
    name: "PageMyApprovalRelease",
    component: PageMyApprovalRelease,
    props: true,
  },
  {
    path: "/MyReleaseOrderAuthForm",
    name: "PageMyApprovalReleaseForm",
    component: PageMyApprovalReleaseForm,
    props: true,
  },
  {
    path: "/MyReleaseOrderForm",
    name: "PageMyReleaseOrderForm",
    component: PageMyReleaseOrderForm,
    props: true,
  },
  {
    path: "/SearchReleaseOrder",
    name: "PageSearchReleaseOrder",
    component: PageSearchReleaseOrder,
    props: true,
  },
  {
    path: "/MyReservationInfoForAuth",
    name: "PageMyApprovalReleaseReservationInfo",
    component: PageMyApprovalReleaseReservationInfo,
    props: true,
  },
]
